import script from "./RemoveBGTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveBGTerms.vue?vue&type=script&setup=true&lang=js"

import "./RemoveBGTerms.vue?vue&type=style&index=0&id=746cffb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746cffb3"]])

export default __exports__